import { render, staticRenderFns } from "./formerUniverse.vue?vue&type=template&id=fea29e0a"
import script from "./formerUniverse.vue?vue&type=script&lang=js"
export * from "./formerUniverse.vue?vue&type=script&lang=js"
import style0 from "./formerUniverse.vue?vue&type=style&index=0&id=fea29e0a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports